export default __webpack_public_path__ + "static/media/Baby38.79501d92.gif";